import { render, staticRenderFns } from "./CartTotals.vue?vue&type=template&id=16dd41e3"
import script from "./CartTotals.ts?vue&type=script&lang=ts&external"
export * from "./CartTotals.ts?vue&type=script&lang=ts&external"
import style0 from "./CartTotals.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports